// extracted by mini-css-extract-plugin
module.exports = {"row":"Home_row__1hWxg","col-sidebar":"Home_col-sidebar__3iRYO","col":"Home_col__1mYz0","Post_192":"Home_Post_192__2hkVV","Message":"Home_Message__2jMFJ"};